<template>
  <span>{{timeText}}</span>
</template>

<script>
import Vue from 'vue'

export default {
  name: 'timeCounter',
  props: {
    startTime: {
      type: Number,
      default: 180
    }
  },  
  data () {
    return {
      time: this.startTime,
      timeText: '03:00',
      interval: null
    }
  },
  mounted () {
    this.toHourMinSec(this.startTime);
  },  
  methods: {
    startCounter() {
      this.time = this.startTime;

      clearInterval(this.interval); 
      this.interval = setInterval(this.decrementTime, 1000); 
    },
    decrementTime() { 
      if (this.time > 0) {
        this.time = parseInt(this.time) - 1;
        this.toHourMinSec(this.time); 
      }
    },
    toHourMinSec(t) { 
      var hour;
      var min;
      var sec;

		  // 정수로부터 남은 시, 분, 초 단위 계산
      hour = Math.floor(t / 3600);
      min  = Math.floor( (t-(hour*3600)) / 60 );
      sec  = t - (hour*3600) - (min*60);

      // hh:mm:ss 형태를 유지하기 위해 한자리 수일 때 0 추가
      if(hour < 10) hour = "0" + hour;
      if(min < 10) min = "0" + min;
      if(sec < 10) sec = "0" + sec;

      // 분, 초만 표시
      this.timeText = min + ":" + sec;
 	  }
  }      
}
</script>


// WEBPACK FOOTER //
// src/components/TimeCounter.vue